/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Sc_AgentsInputs */

const en_mk_tut_sc_agents = /** @type {(inputs: Mk_Tut_Sc_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to the Agents page`)
};

const id_mk_tut_sc_agents = /** @type {(inputs: Mk_Tut_Sc_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lompat ke halaman Agen`)
};

/**
* | output |
* | --- |
* | "Jump to the Agents page" |
*
* @param {Mk_Tut_Sc_AgentsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_sc_agents = /** @type {((inputs?: Mk_Tut_Sc_AgentsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Sc_AgentsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_sc_agents(inputs)
	return en_mk_tut_sc_agents(inputs)
});